/* ==========================================================================
   Select > Client
   ========================================================================== */

/* Import modules */
const { elementExist } = require('@bluekiri/alexandria/helpers/domHelpers');
const { randomId } = require('@bluekiri/alexandria/helpers/dataHelpers');
const prototype = require('./prototype');
const config = require('./config');

/**
 * Select component
 * @param {selector} String selector for the component in the client side.
 */
module.exports = function SelectClient(selector = '[data-component="Select"]', configuration = {}) {
    if (elementExist(selector)) {
        /* Create the instance based on prototype */
        const instance = Object.create(prototype);

        /* Element reference */
        instance.element = document.querySelector(selector);

        /* Config */
        instance.config = {
            ...config(),
            ...configuration,
            choices: {
                ...config().choices,
                ...configuration.choices,
                choices: instance.element.dataset.items ? JSON.parse(instance.element.dataset.items) : []
            }
        };

        /* Id reference */
        instance.id = randomId(randomId('select'));

        /* Init error handler */
        instance.error = false;

        /* Value reference */
        instance.value = instance.getSelect().value;

        /* Auto init */
        if (instance.config.init) instance.init();

        return instance;
    }
};
